<template>
    <span class="card-challenge-result-declaration-incomplete">{{ declarationText }}</span>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 8,
                    status: "ONGOING",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 3,
                        username: "kral1790",
                        status: "WAIT-PRACTICE"
                    }
                }
            },
        },

        computed: {
            declarationText(){
                if(this.resultItem.user2.status === 'REJECTED'){
                    return 'REDDEDİLDİ';
                }
                return 'BEKLENİYOR';
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-result-declaration-incomplete.css"></style>